import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { Collapse } from 'reactstrap';
import { GlobalAppContext } from '@context';

const MobileMenuLayout = ({ children }) => {
  const { state: { isMobileNavOpen } } = useContext(GlobalAppContext);
  return (
    <Collapse isOpen={isMobileNavOpen} className="d-md-none">{children}</Collapse>
  );
};

MobileMenuLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default MobileMenuLayout;
